/**
 * @generated SignedSource<<c2bd0a4b263f879c841ecd038c2c6c18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OccurrenceRegisterAndRSVPButtonFragment$data = {
  readonly id: string;
  readonly product: {
    readonly id: string;
    readonly slug: string;
    readonly type: ProductType;
  };
  readonly " $fragmentType": "OccurrenceRegisterAndRSVPButtonFragment";
};
export type OccurrenceRegisterAndRSVPButtonFragment$key = {
  readonly " $data"?: OccurrenceRegisterAndRSVPButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrenceRegisterAndRSVPButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OccurrenceRegisterAndRSVPButtonFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};
})();

(node as any).hash = "bca76ebb2e634c65219cf39a6699b478";

export default node;
